import React from 'react';
import { StyleSheet, View } from 'react-native';

import { BodyText, theme } from '@sg/garnish';

// ────────────────────────────────────────────────────────────────────────────

export const BagDisclosure = (props: BagDisclosureProps) => {
  return (
    <View style={styles.container} {...props}>
      <BodyText sizeMatch={['12']}>{props.disclosure}</BodyText>
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
    marginTop: theme.spacing['4'],
    paddingVertical: theme.spacing['2'],
    paddingHorizontal: theme.spacing['4'],
    borderRadius: theme.radius.small,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type BagDisclosureProps = {
  disclosure: string;
};
